export default {"src":"/_next/static/media/stopped-clock-noloop.4d5ce20f.gif","height":240,"width":426,"blurWidth":0,"blurHeight":0};